import React from "react";
import { useCart } from "../Cart/CartContext";
import savageBot from "../../assets/savageBot.jpg";
import zenBot from "../../assets/zenBot.jpg";
import turboBot from "../../assets/turboBot.jpg";
import neuroFalcon from "../../assets/neurofalcon.jpg";
import bullSynth from "../../assets/bullSynth.jpeg";
import quantamWolf from "../../assets/quantamWolf.jpg";

function EliteSeriesBots({ onBuyNow }) {
  const { addToCart } = useCart();

  const botsArray = [
    {
      id: "1",
      heading: "Savage",
      image: savageBot,
      price: "1500",
      about: "RISE//FALL",
      fileUrl: "/downloads/savage.xml",
    },
    {
      id: "2",
      heading: "Zen Bot",
      image: zenBot,
      price: "1000",
      about: "EVEN",
      fileUrl: "/downloads/zenbot.xml",
    },
    {
      id: "3",
      heading: "Turbo Bot",
      image: turboBot,
      price: "1000",
      about: "ODD",
      fileUrl: "/downloads/turbobot.xml",
    },
    {
      id: "4",
      heading: "NeuroFalcon",
      image: neuroFalcon,
      price: "1000",
      about: "DIGIT",
      fileUrl: "/downloads/neurofalcon.xml",
    },
    {
      id: "5",
      heading: "QuantamWolf",
      image: quantamWolf,
      price: "1300",
      about: "RISE//FALL",
      fileUrl: "/downloads/quantamwolf.xml",
    },
    {
      id: "6",
      heading: "BullSynth",
      image: bullSynth,
      price: "1000",
      about: "RISE//FALL",
      fileUrl: "/downloads/bullsynth.xml",
    },
  ];

  return (
    <>
      <h1 className="custom-h2 my-2">Elite Series</h1>
      <div className="flex overflow-x-auto space-x-4 px-4 mb-4 scrollbar-hide">
        {botsArray.map((bot) => (
          <div key={bot.id} className="flex-shrink-0">
            <div className="group cursor-pointer transition-all duration-500 hover:scale-105 mb-4">
              <div className="relative text-white rounded-3xl border border-white/10 bg-gradient-to-br from-[#010101] via-[#090909] to-[#010101] shadow-2xl backdrop-blur-xl hover:border-white/25 overflow-hidden w-[150px] md:w-[250px] h-auto z-10">
                {/* Background Layer with pointer-events-none */}
                <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none">
                  <div className="absolute inset-0 bg-gradient-to-tr from-white/5 to-white/10 opacity-40 group-hover:opacity-60 transition-opacity duration-500" />
                  <div
                    style={{ animationDelay: "0.5s" }}
                    className="absolute -bottom-20 -left-20 w-10 md:w-48 h-10 md:h-48 rounded-full bg-gradient-to-tr from-white/10 to-transparent blur-3xl opacity-30 group-hover:opacity-50 transform group-hover:scale-110 transition-all duration-700 animate-bounce"
                  />
                  <div className="absolute top-10 left-10 w-16 h-16 rounded-full bg-white/5 blur-xl animate-ping" />
                  <div
                    style={{ animationDelay: "1s" }}
                    className="absolute bottom-16 right-16 w-3 md:w-12 h-3 md:h-12 rounded-full bg-white/5 blur-lg animate-ping"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent transform -skew-x-12 translate-x-full group-hover:translate-x-[-200%] transition-transform duration-1000" />
                </div>

                {/* Foreground Content */}
                <div className="p-1 md:p-4 relative z-10">
                  <div className="flex flex-col items-center text-center">
                    <div className="relative">
                      <div className="absolute inset-0 rounded-full border-2 border-white/20 animate-ping pointer-events-none" />
                      <div
                        style={{ animationDelay: "0.5s" }}
                        className="absolute inset-0 rounded-full border border-white/10 animate-pulse pointer-events-none"
                      />
                      <div className="p-2 md:p-4 rounded-full backdrop-blur-lg border border-white/20 bg-gradient-to-br from-black/80 to-black/60 shadow-2xl transform group-hover:rotate-12 group-hover:scale-110 transition-all duration-500 hover:shadow-white/20">
                        <div className="transform group-hover:rotate-180 transition-transform duration-700">
                          <img
                            src={bot.image}
                            alt=""
                            className="rounded-full w-20 md:w-40 h-10 md:h-20"
                          />
                        </div>
                      </div>
                    </div>

                    <p className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-green-700 via-gray-100 to-green-600 bg-clip-text text-transparent animate-pulse mt-2">
                      {bot.heading}
                    </p>

                    <p className="text-sky-300 text-sm font-semibold leading-relaxed group-hover:text-red-500 transition-colors duration-300">
                      {bot.about}
                    </p>

                    <p>
                      <span className="font-bold text-sky-600">Price:</span>{" "}
                      <span className="text-green-400">
                        <span className="font-bold"> Ksh</span> {bot.price}
                      </span>
                    </p>

                    <div className="w-1/3 h-0.5 bg-gradient-to-r from-transparent via-white to-transparent rounded-full group-hover:w-1/2 group-hover:h-1 transition-all duration-500 animate-pulse mt-1" />

                    <div className="flex space-x-2 mt-2 opacity-60 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                      <div className="w-2 h-2 bg-white rounded-full animate-bounce" />
                      <div
                        style={{ animationDelay: "0.1s" }}
                        className="w-2 h-2 bg-white rounded-full animate-bounce"
                      />
                      <div
                        style={{ animationDelay: "0.2s" }}
                        className="w-2 h-2 bg-white rounded-full animate-bounce"
                      />
                    </div>
                  </div>
                </div>

                {/* ✅ Buttons always clickable */}
                <div className="flex justify-between mx-2 md:mx-10 mb-2 relative z-20">
                  <button
                    className="bg-yellow-600 hover:bg-yellow-500 rounded-md text-white px-3 py-1 text-sm"
                    onClick={() => addToCart(bot)}
                  >
                    Cart
                  </button>
                  <button
                    className="bg-green-600 hover:bg-green-500 rounded-md text-white px-3 py-2 text-sm"
                    onClick={() => onBuyNow(bot)}
                  >
                    Buy
                  </button>
                </div>

                {/* Decorative corners (with pointer-events-none) */}
                <div className="absolute top-0 left-0 w-20 h-20 bg-gradient-to-br from-white/10 to-transparent rounded-br-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                <div className="absolute bottom-0 right-0 w-20 h-20 bg-gradient-to-tl from-white/10 to-transparent rounded-tl-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default EliteSeriesBots;
